import { Alert, AlertTitle } from "@mui/material";
import React, { useState } from "react";
import { Button } from "../../../controls";
import { useTranslation } from "react-i18next";
import { Dialog } from "../../../layout";
import CloseReg from "./CloseReg";
import { formatDate } from "../../../hooks/Method";

const RegClosingAlert = ({ openReg }) => {
  const { t } = useTranslation();
  const [regForm, setRegForm] = useState(false);

  const handleCloseReg = () => {
    setRegForm(true);
  };

  return (
    <>
      <div className="pb-10">
        <Alert
          severity="error"
          action={
            <Button
              onClick={handleCloseReg}
              color="error"
              size="small"
              sx={{ width: "150px" }}
            >
              {t("closeRegister")}
            </Button>
          }
        >
          <AlertTitle>Pending Register Closure</AlertTitle>
          You have an open register from{" "}
          <span className="fw-6">{formatDate(openReg?.openTime)}</span>
          . Please close it before starting a new sale.
          <br />
          <br />
          <strong>
            To maintain accurate daily sales reports, we recommend closing the
            register at the end of each day.
          </strong>
        </Alert>
      </div>
      <Dialog show={regForm} onClose={false} maxWidth="md">
        {regForm && <CloseReg {...{ setShowForm: setRegForm }} />}
      </Dialog>
    </>
  );
};

export default RegClosingAlert;
